/**
 * Give all members an initial position, keep the one they have if already given a position. Else get position 1000.
 */
export const getMembersInitialPositions = (members, positionsInGrid) => {
    const newPositionsInGrid = [];
    for (let i = 0; i < members.size; i++) {
        const hasName = members.get(i).get('displayName');
        const displayName = hasName ? hasName : members.get(i).get('callerId');

        const memberWithPosition = positionsInGrid.find(
            (member) => member.name === displayName,
        );
        newPositionsInGrid.push({
            name: displayName,
            position: memberWithPosition ? memberWithPosition.position : 1000,
        });
    }
    return newPositionsInGrid;
};

const getScreenSharingMembers = (videoMembers) => {
    if (videoMembers) {
        return videoMembers.filter(
            (videoMember) => videoMember.get('screenShareActive') === true,
        );
    } else {
        return [];
    }
};

export const getNumberOfScreenShares = (videoMembers) => {
    const screenSharingMembers = getScreenSharingMembers(videoMembers);
    let count = 0;
    screenSharingMembers.forEach(() => count++);
    return count;
};

/**
 * Separate members into video member, a screen sharing member or a dial-in member
 */
export const separateMemberTypes = (
    members,
    videoMembers,
    ownName,
    positionsInGrid,
) => {
    const screenShareMemberList = [];
    const videoMemberList = [];
    const callerMemberList = [];

    for (let i = 0; i < members.size; i++) {
        const member = members.get(i);
        const displayName = member.get('displayName');
        const videoMember = findVideoMember(videoMembers, displayName);
        const positionName =
            member &&
            positionsInGrid.find((position) => position.name === displayName);
        const position = positionName && positionName.position;
        if (videoMember) {
            const isScreenSharing = isVideoMemberScreenSharing(videoMember);
            if (isScreenSharing) {
                screenShareMemberList.push({
                    member: member,
                    position: position,
                });
            } else {
                videoMemberList.push({ member: member, position: position });
            }
        } else {
            if (!(displayName && displayName === ownName)) {
                callerMemberList.push({ member, position });
            }
        }
    }
    return { screenShareMemberList, videoMemberList, callerMemberList };
};

const findVideoMember = (videoMembers, displayName) => {
    return videoMembers.find(
        (videoMember) => videoMember.get('name') === displayName,
    );
};

const isVideoMemberScreenSharing = (videoMember) => {
    if (videoMember) {
        return videoMember.get('screenShareActive');
    } else {
        return false;
    }
};

/**
 * Sort video members, screen sharing members and dial-ins separately.
 */
export const sortMemberTypes = (
    videoMemberList,
    screenShareMemberList,
    callerMemberList,
) => {
    videoMemberList.sort((a, b) => a.position - b.position);
    screenShareMemberList.sort((a, b) => a.position - b.position);
    callerMemberList.sort((a, b) => {
        const aTime = a.member.get('joinTime');
        const bTime = b.member.get('joinTime');
        if (aTime < bTime) {
            return -1;
        }
        if (aTime > bTime) {
            return 1;
        }
        return -1;
    });
};

/**
 * Find what positions in the grid are free to fill with dial-in members,
 * i.e. the slots not taken by a member in the list membersToRender
 */
export const getFreePositionsInGrid = (
    membersToRender,
    numberOfSlotsInGrid,
) => {
    let freePositions = Array(numberOfSlotsInGrid)
        .fill()
        .map((_, index) => numberOfSlotsInGrid - index);
    for (let i = 0; i < membersToRender.length; i++) {
        freePositions = freePositions.filter(
            (position) => position !== membersToRender[i].position,
        );
    }
    return freePositions;
};
